import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { UitkRating, UitkRatingIcon } from 'uitk-react-rating';

interface StarsProps {
  stars: number;
  starRatingIcon: string;
}

export const Stars: React.FunctionComponent<StarsProps> = ({ stars, starRatingIcon }) => {
  if (!stars) {
    return null;
  }

  return (
    <div className="all-b-padding-half">
      <span className="is-visually-hidden">
        <LocalizedText message={'hotels.searchResults.filtersDialog.starRating.label'} />
      </span>
      <UitkRating icon={UitkRatingIcon[starRatingIcon]} rating={String(stars)} />
    </div>
  );
};
